import axios from 'axios'
import lodash from './lodash'

import Config from '../config';

import store from '../store';

import {
    AUTH_HEADER_TOKEN
} from "./constants"

function authHeader() {
    return {
        [AUTH_HEADER_TOKEN]: `Bearer ${store.state.sessionToken}`
    }
}

export default {
    get: (url, config) => {
        let allConfig = {
            headers: authHeader()
        }
        if (config) {
            allConfig = lodash.merge(allConfig, config)
        }
        return axios.get(`${Config.backendUrl}/${url}`, allConfig).then(res => {
            console.log(res.request.responseURL)
            return res;
        })
    },
    post: (url, body, config) => {
        let allConfig = {
            headers: authHeader()
        }
        if (config) {
            allConfig = lodash.merge(allConfig, config)
        }
        return axios.post(`${Config.backendUrl}/${url}`, body, allConfig)
    },
    delete: (url, body, config) => {
        let allConfig = {
            headers: authHeader()
        }
        if (config) {
            allConfig = lodash.merge(allConfig, config)
        }
        return axios.delete(`${Config.backendUrl}/${url}`, allConfig)
    },
    all: axios.all


};


